import { useTranslation } from 'react-i18next'
import styled, { css } from 'styled-components'
import { theme } from '../../theme/theme'
import { BodySmall } from '../styles/Typography'

/**
 * `chart` fills a ChartCard's empty chart slot. `tileBoxed` is the same box sized down to a tile's
 * value line, and `tileBoxedHighlight` is that box on the plum tile, where the grey ink falls below AA.
 * `tile` drops the box and only sets the ink.
 */
type Variant = 'chart' | 'tileBoxed' | 'tileBoxedHighlight' | 'tile'

type Props = {
  variant?: Variant
}

export const NotEnoughScreeningData = ({ variant = 'chart' }: Props) => {
  const { t } = useTranslation()

  return <Message $variant={variant}>{t('admin.statistics.notEnoughScreeningData')}</Message>
}

export const NotEnoughFollowUpData = ({ variant = 'chart' }: Props) => {
  const { t } = useTranslation()

  return <Message $variant={variant}>{t('admin.statistics.notEnoughFollowUpData')}</Message>
}

const boxed = css`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
`

const tileBox = css`
  ${boxed}
  padding: ${theme.spacing.xsmall}px ${theme.spacing.small}px;
  border-radius: ${theme.spacing.xsmall}px;
`

const VARIANT_STYLES = {
  chart: css`
    ${boxed}
    min-height: 140px;
    padding: ${theme.spacing.medium}px;
    border-radius: 12px;
    color: ${theme.color.grey4};
    border: 1px solid ${theme.color.grey2};
  `,
  tileBoxed: css`
    ${tileBox}
    color: ${theme.color.grey4};
    border: 1px solid ${theme.color.grey2};
  `,
  tileBoxedHighlight: css`
    ${tileBox}
    color: ${theme.color.beigeLight};
    border: 1px solid ${theme.color.beigeLight};
  `,
  tile: css`
    color: ${theme.color.grey5};
  `,
} satisfies Record<Variant, ReturnType<typeof css>>

const Message = styled(BodySmall)<{ $variant: Variant }>`
  ${({ $variant }) => VARIANT_STYLES[$variant]}
`
